<template>
  <div class="list_tab_cont_inner">
    <ul class="shop_list">
      <li v-for="index in 4" :key="index">
        <div class="thumb_shop_wrap">
          <div class="thumb_shop">
            <div class="inner">
              <vue-skeleton-loader :color="color" />
            </div>
          </div>
        </div>
        <div class="txt">
          <h1>
            <vue-skeleton-loader
              :height="30"
              :width="100"
              :rounded="true"
              :color="color"
            />
          </h1>
          <dl class="txt_dl">
            <vue-skeleton-loader :height="20" :rounded="true" :color="color" />
          </dl>
          <dl class="txt_dl" style="margin-top: 0.3rem">
            <vue-skeleton-loader :height="20" :rounded="true" :color="color" />
          </dl>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'component-skeleton-store-item',
  data() {
    return {
      color: 'rgba(0, 0, 0, 0.07)',
    };
  },
};
</script>

<style scoped></style>
